import React from 'react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import TrimmedMarkdownRender from '@/components/text-editors/TrimmedMarkdownRender';
import PanelContainer from '@/components/wrappers/PanelContainer';
import { fetchConfig } from '@/hooks/fetch';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const RequestMarkdownPanelAll = ({
  category,
  code,
  onChange,
  url,
}) => {
  const intl = useIntl();
  const {
    canRead, name, readErrors, readStatus, text,
  } = Selectors.useRequestMarkdownPanelAll({ category, code });
  Fetch.useFetchRequestMarkdown(
    { category, code },
    readStatus,
    fetchConfig([category, code, readStatus]),
  );

  return (
    <PanelContainer
      canAccess={canRead}
      entity="request.read"
      exists
      name={readStatus === states.SUCCESS ? intl.formatMessage({ id: 'tabs.reader.of' }, { name }) : name}
      onChange={onChange}
      readErrors={readErrors}
      readStatus={[readStatus]}
      url={url}
    >
      <TrimmedMarkdownRender text={text} withMessage />
    </PanelContainer>
  );
};

export default RequestMarkdownPanelAll;
